module.exports = __webpack_public_path__ + "static/media/可视化2.b6c8c0f3.png";